// extracted by mini-css-extract-plugin
export default {"root":"_2Nly5","outro":"PfF-d","info":"ekb9Y","name":"gQSHU","submit":"vF93B","submitted":"LSQHz","form-error":"lfwv0"};